import {Component, inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BaseComponent,
  WmsDialogBodyComponent,
  WmsDialogComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent
} from "@wms/components";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {DialogService} from "@wms/services";
import {AddCustomIconTemplateComponent} from "@wms/app/add-custom-icon-template/add-custom-icon-template.component";
import * as events from "events";

@Component({
  selector: 'wms-import-icons',
  standalone: true,
  imports: [CommonModule, WmsDialogComponent, WmsDialogHeaderComponent, ReactiveFormsModule, WmsDialogBodyComponent, FormsModule, WmsDialogFooterComponent, AddCustomIconTemplateComponent],
  templateUrl: './import-icons.component.html',
  styleUrls: ['./import-icons.component.less']
})
export class ImportIconsComponent  extends  BaseComponent{
  dialogeService: DialogService
  dialogeAction: boolean = true;
  cssFile: string = '';
  ttfFile: string = '';
  libName: string = '';


  constructor() {
    super();
    this.dialogeService = inject(DialogService);
  }


  onClose() {
    this.dialogeService.close('importIconsDialoge')
  }

  enableActions(event: any) {
    if (event.fileType === 'ttf') {
      this.ttfFile = event.value
    } else if(event.fileType === 'css') {
      this.cssFile = event.value
    }else {
      this.libName = event.value
    }

  }
  save(){

    this.eventManager.emitOnIconSave()
  }


}
